import { useEffect, useContext, useState } from "react";
import { get, post, remove } from "../../../../adapters/xhr/api";
import Moment from "moment";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "../common/FieldRendrer";
import { validateRequired, validateFile } from "../../../../helpers/Validation";
import { DatePickerFormatedWithLimit } from "../../../../shared/form/DatePickerFormated";
import Modal from "react-modal";
import stylesModal from "./Modal.module.css";
import { useLocation, useParams } from "react-router-dom";
import CommonAddressMap from "../../../../shared/pages/map/CommonAddressMap";
import infoIconSvg from "../../../../assets/img/Icon-metro-info.svg";
import InfoPopover from "../../../../shared/form/InfoPopover";
import {
  validateManualCommonAddress,
  validateManualBuildingMatch,
  validateBuildingFilterSearchType,
  hasFilterSearchTypeMismatch,
  getMatchingBuildings,
} from "../../helpers/commonValidation";
import { getManualCommonBuilding } from "../../helpers/constants";

const ServiceFacilityForm = ({
  generateOptions,
  residentialUnitTypes,
  error_new_user,
  setValidFields,
  handleChangeDeclerationUnit,
  ownershipDeedFileInputRef,
  leaseContractFileInputRef,
  setUploadFileError,
  setError,
  fileInputKeys,
  DownloadFile,
  handlePreviewFile,
  constructionLicenseFileInputRef,
  openingBudgetFileInputRef,
  allBookValueFileInputRef,
  operationLicenseFileInputRef,
  articlesOfAssociationFileInputRef,
  setTempFiles,
  unitBuildingMapError,
  setUnitBuildingMapError,
  unitMapError,
  setUnitMapError,
  setBackendError,
  setSubmissionError,
}) => {
  const location = useLocation();
  const { id } = useParams();
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    updateDeclarationUnit,
    isUnitInSameBuilding,
    reasonForExemption,
    setDeclarationRequest,
    building,
    setBuilding,
    isBuildingEditMode,
    setIsBuildingEditMode,
    isDuplicateRenin,
    setIsDuplicateRenin,
    errorBuilding,
    setErrorBuilding,
    dataMismatchReasonLookup,
    DoYouWantExtraAttachmentsForRequestTypes,
    getLabelById,
    buildingFullAddressDisplay,
    staticGovs,
  } = unifiedTaxDeclarationContext;

  const [burdenActivityTypes, setBurdenActivityTypes] = useState([]);
  const [fileErrors, setFileErrors] = useState({});
  const [staticBuilding, setStaticBuilding] = useState(null);
  const [buildingsBeforeEdit, setBuildingsBeforeEdit] = useState(null);
  const [serviceFacilityFormError, setServiceFacilityFormError] = useState("");
  const [showDeleteOther, setShowDeleteOther] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const selectedExemptionReason = reasonForExemption?.find(
    (reason) =>
      String(reason?.id) === String(declarationRequest?.unit?.exemption_reason),
  );

  const exemptedValue = String(
    declarationRequest?.unit?.exempted ?? "",
  ).toLowerCase();
  const isExempted =
    declarationRequest?.unit?.exempted === 1 ||
    declarationRequest?.unit?.exempted === true ||
    exemptedValue === "1" ||
    exemptedValue === "true";

  const isSpecialLawReason =
    selectedExemptionReason?.name?.includes("إعفاء بقانون خاص") ||
    String(declarationRequest?.unit?.exemption_reason) === "11";

  const [isAddBuildingButtonDisabled, setIsAddBuildingButtonDisabled] =
    useState("");
  const [buildingValidFields, setBuildingValidFields] = useState({
    floors_count: false,
    building_area: false,
    manual_governorate_id: false,
    manual_policestation_id: false,
    manual_known_build_num: false,
  });

  const [showModal, setShowModal] = useState(false);
  const [serviceFacilityToDelete, setserviceFacilityToDelete] = useState(null);

  const totalBuildingsArea = Array.isArray(
    getMatchingBuildings(declarationRequest),
  )
    ? getMatchingBuildings(declarationRequest).reduce(
        (acc, b) => acc + parseFloat(b.building_area || 0),
        0,
      )
    : 0;

  const canEditUnit =
    !declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode;

  useEffect(() => {
    // Only update if the value actually changed to avoid infinite loops
    if (declarationRequest?.unit?.total_building_area !== totalBuildingsArea) {
      updateDeclarationUnit("total_building_area", totalBuildingsArea);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalBuildingsArea]);

  const setEachErrorBuilding = (key, value) => {
    setErrorBuilding((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleUpdateBuilding = (pc, c, field, value) => {
    setBuilding({
      ...building,
      [field]: value,
    });
  };

  const formFields = ({
    declarationRequest,
    error_new_user,
    handleChangeDeclerationUnit,
    stylesRequestData,
  }) => [
    {
      type: "input",
      colClass: "col-md-4",
      name: "facility_name",
      labelText: "اسم المنشأة",
      placeholder: "ادخل اسم المنشأة..",
      labelHtmlFor: "facility_name",
      inputType: "text",
      maxLength: 100,
      allowedPattern: /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/,
      value: declarationRequest?.unit?.facility_name,
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.facility_name,
      stylesRequestData,
      required: true,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "total_land_area",
      labelText: "مساحة الأرض الكلية",
      placeholder: "ادخل مساحة الأرض الكلية..",
      labelHtmlFor: "total_land_area",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.total_land_area || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.total_land_area,
      stylesRequestData,
      required: true,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "buildings_count",
      labelText: "عدد المباني",
      placeholder: "ادخل عدد المباني..",
      labelHtmlFor: "buildings_count",
      inputType: "number",
      min: 1,
      step: 1,
      maxLength: 10,
      allowedPattern: /^[1-9]\d{0,9}$/,
      value: declarationRequest?.unit?.buildings_count || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.buildings_count
        ? error_new_user?.buildings_count
        : serviceFacilityFormError,
      stylesRequestData,
      required: true,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "total_building_area",
      labelText: "إجمالي مساحة المباني",
      labelHtmlFor: "total_building_area",
      inputType: "text",
      value: declarationRequest?.unit?.total_building_area || 0,
      disabled: true,
      stylesRequestData,
    },
  ];

  const validateBeforeSubmitBuilding = () => {
    let isFormValid = true;
    let isManualValid = true;

    if (!validateRequired(building?.floors_count)) {
      setBuildingValidFields((prev) => ({
        ...prev,
        floors_count: false,
      }));
      setEachErrorBuilding("floors_count", "يجب إدخال عدد الأدوار");
      isFormValid = false;
    } else {
      setEachErrorBuilding("floors_count", "");
      setBuildingValidFields((prev) => ({
        ...prev,
        floors_count: true,
      }));
    }

    if (!validateRequired(building?.building_area)) {
      setBuildingValidFields((prev) => ({
        ...prev,
        building_area: false,
      }));
      setEachErrorBuilding("building_area", "يجب إدخال مساحة المبنى");
      isFormValid = false;
    } else {
      setEachErrorBuilding("building_area", "");
      setEachErrorBuilding((prev) => ({
        ...prev,
        building_area: true,
      }));
    }

    if (building?.main_building !== 1) {
      if (parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3) {
        if (
          !validateRequired(
            declarationRequest?.unit?.building?.is_map_address_matching,
          )
        ) {
          setEachErrorBuilding((prev) => ({
            ...prev,
            is_map_address_matching: false,
          }));
          setEachErrorBuilding("is_map_address_matching", "يجب اختيار إجابة");
          isFormValid = false;
        } else {
          // Rule 2: if no known_build_num AND is_map_address_matching === 1 → special error
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.buildingProfile?.number,
            ) &&
            parseInt(
              declarationRequest?.unit?.building?.is_map_address_matching,
            ) === 1
          ) {
            setEachErrorBuilding((prev) => ({
              ...prev,
              is_map_address_matching: false,
            }));
            setEachErrorBuilding(
              "is_map_address_matching",
              "لا يمكن الإستمرار بالإجابة “نعم” لعدم توفر رقم العقار، برجاء تصحيح البيانات و إدخال رقم العقار/المبنى المتعارف عليه",
            );
            isFormValid = false;
          } else {
            // If known_build_num is provided, clear its error
            setEachErrorBuilding((prev) => ({
              ...prev,
              is_map_address_matching: true,
            }));
            setEachErrorBuilding("is_map_address_matching", "");
          }
        }

        if (
          parseInt(
            declarationRequest?.unit?.building?.is_map_address_matching,
          ) === 2
        ) {
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.mismatch_reason_id,
            )
          ) {
            setEachErrorBuilding((prev) => ({
              ...prev,
              mismatch_reason_id: false,
            }));
            setEachErrorBuilding("mismatch_reason_id", "يجب اختيار إجابة");
            isFormValid = false;
          } else {
            setEachErrorBuilding("mismatch_reason_id", "");
            setEachErrorBuilding((prev) => ({
              ...prev,
              mismatch_reason_id: true,
            }));
          }
        }

        if (
          !validateRequired(
            declarationRequest?.unit?.building?.buildingProfile?.number,
          )
        ) {
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.known_build_num,
            )
          ) {
            setEachErrorBuilding((prev) => ({
              ...prev,
              known_build_num: false,
            }));
            setEachErrorBuilding(
              "known_build_num",
              "يجب إدخال رقم العقار/المبنى المتعارف عليه",
            );
            isFormValid = false;
          } else {
            setEachErrorBuilding("known_build_num", "");
            setEachErrorBuilding((prev) => ({
              ...prev,
              known_build_num: true,
            }));
          }
        } else {
          setEachErrorBuilding("known_build_num", "");
          setEachErrorBuilding((prev) => ({
            ...prev,
            known_build_num: true,
          }));
        }
      } else {
        isManualValid = validateManualCommonAddress(
          declarationRequest,
          validateRequired,
          setError,
          setValidFields,
          false,
        );
      }
    } else {
      if (parseInt(declarationRequest?.unit?.filter_search_type_id) === 3) {
        isManualValid = validateManualCommonAddress(
          declarationRequest,
          validateRequired,
          setError,
          setValidFields,
          true,
        );
      } else {
        isManualValid = true;
      }
    }

    // if (
    //   !validateRequired(building?.buildingProfile?.number) ||
    //   building?.buildingProfile?.number == 0
    // ) {
    //   if (!validateRequired(building?.known_build_num)) {
    //     setBuildingValidFields((prev) => ({
    //       ...prev,
    //       known_build_num: false,
    //     }));
    //     setEachErrorBuilding(
    //       "known_build_num",
    //       "يجب إدخال رقم العقار/المبنى المتعارف عليه",
    //     );
    //     isFormValid = false;
    //   } else {
    //     setEachErrorBuilding("known_build_num", "");
    //     setBuildingValidFields((prev) => ({
    //       ...prev,
    //       known_build_num: true,
    //     }));
    //   }
    // }

    return isFormValid && isManualValid;
  };

  const fields = formFields({
    declarationRequest,
    error_new_user,
    residentialUnitTypes,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
  });

  const secondaryFields = [
    {
      type: "input",
      colClass: "col-md-4",
      name: "activity_type",
      labelText: "نوع النشاط",
      placeholder: "ادخل نوع النشاط..",
      labelHtmlFor: "activity_type",
      inputType: "text",
      maxLength: 100,
      allowedPattern:
        /^(?!.*[0-9])[A-Za-z\u0621-\u063A\u0641-\u064A\-_,.\/\\\s]+$/,
      value: declarationRequest?.unit?.activity_type || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.activity_type,
      stylesRequestData,
      required: true,
    },
    {
      type: "checkbox",
      name: "exempted",
      id: "exempted",
      labelHtmlFor: "exempted",
      required: false,
      text: "هل المنشأة معفاه؟",
      secondText: "الدليل المستخدم",
      checked: isExempted,
      onChange: (e) => {
        const checked = e.target.checked ? 1 : 0;
        handleChangeDeclerationUnit("", "", "exempted", checked);
        if (!checked) {
          handleChangeDeclerationUnit("", "", "exemption_reason", null);
          handleChangeDeclerationUnit("", "", "law_number", null);
          handleChangeDeclerationUnit("", "", "law_year", null);
        }
      },

      disabled:
        declarationRequest?.viewMode ||
        declarationRequest?.isUnitViewMode ||
        isUnitInSameBuilding,
      errorText: error_new_user?.exempted,

      labelClassName: `${stylesRequestData["list-group-item"]} list-group-item border-0 mb-3`,
      inputClassName: `${stylesRequestData["form-check-input"]} form-check-input ms-3 mt-2`,
      textStyle: { fontSize: "20px", fontWeight: "bold" },
      errorClassName: "text-danger mb-0 mt-1 me-4 fw-bolder",
      errorId: "exempted_error",
      popover: {
        content:
          "إعفاء الأبنية المملوكة للجمعيات: يشترط ان تكون الجمعية مسجلة وفقاً لأحكام القانون وان يكون العقار مستغل في الأغراض التي أنشئت من اجلها ولا يسري الاعفاء متي كانت تؤجر الوحدات المملوكة لها للغير ويراعي ارفاق كافة المستندات المؤيدة. إعفاء الأبنية المملوكة للمنظمات العمالية: يشترط ان تكون الابنية مخصصة لمكاتب ادارتها أو للأغراض التي أنشئت من اجلها ولا يسري الاعفاء متي كانت تؤجر الوحدات المملوكة لها للغير ويراعي ارفاق كافة المستندات المؤيدة. إعفاء المؤسسات التعليمية: يشترط ان تكون غير هادفة للربح ولا يسري الاعفاء متي كانت تؤجر الوحدات المملوكة لها للغير ويراعي ارفاق كافة المستندات المؤيدة. إعفاء المستشفيات والمستوصفات: يشترط ان تكون غير هادفة للربح ولا يسري الاعفاء متي كانت تؤجر الوحدات المملوكة لها للغير ويراعي ارفاق كافة المستندات المؤيدة. إعفاء الملاجئ والمبرات: يشترط ان تكون غير هادفة للربح ولا يسري الاعفاء متي كانت تؤجر الوحدات المملوكة لها للغير ويراعي ارفاق كافة المستندات المؤيدة. إعفاء الأبنية المملوكة للأحزاب السياسية: يشترط ان تكون الابنية مستخدمة في الأغراض المخصصة لها ولا يسري الاعفاء متي كانت تؤجر الوحدات المملوكة لها للغير ويراعي ارفاق كافة المستندات المؤيدة. إعفاء النقابات المهنية: يشترط ان تكون الابنية مستخدمة في الأغراض المخصصة لها ولا يسري الاعفاء متي كانت تؤجر الوحدات المملوكة لها للغير ويراعي ارفاق كافة المستندات المؤيدة. الدور المخصصة للمناسبات الاجتماعية: يشترط ان تكون غير هادفة للربح ولا يسري الاعفاء متي كانت تؤجر الوحدات المملوكة لها للغير ويراعي ارفاق كافة المستندات المؤيدة. إعفاءات مقررة بقوانين خاصة: يتم توضيح السند القانوني وتحديد رقم القانون ونص الاعفاء ويراعي ارفاق كافة المستندات المؤيدة.",
      },
      stylesRequestData,
    },
    ...(isExempted
      ? [
          {
            type: "select",
            colClass: "col-md-4 mt-3",
            name: "exemption_reason",
            labelText: "سبب الإعفاء",
            labelHtmlFor: "exemption_reason",
            options: generateOptions(reasonForExemption),
            defaultText: "اختار سبب الإعفاء..",
            value:
              declarationRequest?.unit?.exemption_reason !== null &&
              declarationRequest?.unit?.exemption_reason !== undefined
                ? String(declarationRequest?.unit?.exemption_reason)
                : null,
            onChange: (pc, c, key, value) => {
              handleChangeDeclerationUnit(pc, c, key, value);
              const selected = reasonForExemption?.find(
                (reason) => String(reason?.id) === String(value),
              );
              if (!selected || !selected?.name?.includes("إعفاء بقانون خاص")) {
                handleChangeDeclerationUnit("", "", "law_number", null);
                handleChangeDeclerationUnit("", "", "law_year", null);
              }
            },
            errorText: error_new_user?.exemption_reason,
            stylesRequestData,
            required: true,
            valueType: "string",
            disabled:
              declarationRequest?.viewMode ||
              declarationRequest?.isUnitViewMode ||
              isUnitInSameBuilding,
          },
          ...(isSpecialLawReason
            ? [
                {
                  type: "input",
                  colClass: "col-md-4 mt-3",
                  name: "law_number",
                  labelText: "رقم القانون",
                  placeholder: "ادخل رقم القانون..",
                  labelHtmlFor: "law_number",
                  inputType: "text",
                  maxLength: 100,
                  allowedPattern:
                    /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/,
                  value: declarationRequest?.unit?.law_number || "",
                  disabled:
                    declarationRequest?.viewMode ||
                    declarationRequest?.isUnitViewMode ||
                    isUnitInSameBuilding,
                  onChange: handleChangeDeclerationUnit,
                  errorText: error_new_user?.law_number,
                  stylesRequestData,
                  required: true,
                },
                {
                  type: "input",
                  colClass: "col-md-4 mt-3",
                  name: "law_year",
                  labelText: "سنة القانون",
                  placeholder: "ادخل سنة القانون..",
                  labelHtmlFor: "law_year",
                  inputType: "text",
                  maxLength: 100,
                  allowedPattern:
                    /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/,
                  value: declarationRequest?.unit?.law_year || "",
                  disabled:
                    declarationRequest?.viewMode ||
                    declarationRequest?.isUnitViewMode ||
                    isUnitInSameBuilding,
                  onChange: handleChangeDeclerationUnit,
                  errorText: error_new_user?.law_year,
                  stylesRequestData,
                  required: true,
                },
              ]
            : []),
        ]
      : []),
    {
      type: "input",
      colClass: "col-md-4 mt-3",
      name: "market_value",
      labelText: "القيمة السوقية للمنشأة",
      placeholder: "ادخل القيمة السوقية للمنشأة..",
      labelHtmlFor: "market_value",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,19}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.market_value || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.market_value,
      stylesRequestData,
      required: false,
    },
  ];

  const handleChangeUnitFile = async (pc, c, key, value, i, bi, fi, ref) => {
    // if (value && !validateFile(value, ["image/png", "image/jpeg", "image/jpg", "application/pdf", "image/jfif"])) {
    //   setError(key, "الملف غير صالح (تأكد من الحجم والامتداد واسم الملف)");
    //   return;
    // }
    try {
      const data = new FormData();
      data.append(`label`, key);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: response?.data?.data,
        // }));
        updateDeclarationUnit(key, response?.data?.data);
        setError(key, "");
        setUploadFileError(null);
        setFileErrors((prev) => ({ ...prev, [key]: "" }));
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: null,
        // }));
        updateDeclarationUnit(key, null);
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
        setFileErrors((prev) => ({
          ...prev,
          [key]: error?.response?.data?.errors?.file?.[0] || "خطأ في الملف",
        }));
        if (ref?.current) {
          ref.current.value = null;
        }
      }
    }
  };

  useEffect(() => {
    if (!parseInt(declarationRequest?.unit?.buildings_count)) {
      setIsAddBuildingButtonDisabled(true);
    } else if (
      getMatchingBuildings(declarationRequest)?.length ===
      parseInt(declarationRequest?.unit?.buildings_count || 1)
    ) {
      setIsAddBuildingButtonDisabled(true);
    } else if (
      getMatchingBuildings(declarationRequest)?.length >=
      parseInt(declarationRequest?.unit?.buildings_count || 1)
    ) {
      setIsAddBuildingButtonDisabled(true);
    } else {
      setIsAddBuildingButtonDisabled(false);
    }
  }, [
    declarationRequest?.unit?.buildings_count,
    declarationRequest?.unit?.buildings,
    getMatchingBuildings(declarationRequest),
  ]);

  useEffect(() => {
    if (
      parseInt(declarationRequest?.unit?.buildings_count || 1) <
      getMatchingBuildings(declarationRequest)?.length
    ) {
      setServiceFacilityFormError(
        "يجب أن يكون عدد المباني أكبر من إجمالي المباني المُدخلة أو مساويًا لها",
      );
    } else if (
      parseInt(declarationRequest?.unit?.buildings_count || 1) ===
      getMatchingBuildings(declarationRequest)?.length
    ) {
      setServiceFacilityFormError("");

      setIsAddBuildingButtonDisabled(true);
    } else {
      setServiceFacilityFormError("");
      setIsAddBuildingButtonDisabled(false);
    }
  }, [declarationRequest?.unit?.buildings_count]);

  useEffect(() => {
    if (
      !declarationRequest?.unit?.building?.buildingProfile &&
      parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3
    ) {
      setIsAddBuildingButtonDisabled(true);
    } else {
      setIsAddBuildingButtonDisabled(false);
    }
  }, [declarationRequest?.unit?.building?.buildingProfile]);

  useEffect(() => {
    setIsDuplicateRenin("");
    setUnitBuildingMapError("");
    setUnitMapError("");
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings_count: declarationRequest?.unit?.buildings_count || 1,
      },
    }));
  }, []);

  useEffect(() => {
    setIsDuplicateRenin("");
    setUnitBuildingMapError("");
    setUnitMapError("");
  }, [declarationRequest?.filter_search_type_id]);

  const canAppendBuilding = (newBuildingProfile, existingBuildings = []) => {
    if (!newBuildingProfile?.renin) return false; // must have renin

    if (parseInt(building?.mismatch_reason_id) === 3) {
      return true;
    } else {
      return !existingBuildings
        .filter((b) => parseInt(b?.mismatch_reason_id) !== 3)
        .some((b) => b?.buildingProfile?.renin == newBuildingProfile.renin);
    }
  };

  const validateBuildingProfileMatch = (unitProfile, buildingProfile) => {
    if (!unitProfile || !buildingProfile) return false;

    const unitIds = unitProfile.address_ids ?? {};
    const buildingIds = buildingProfile.address_ids ?? {};

    const keysToCheck = [
      "district_id",
      "goveronrate_id",
      "city_id",
      "policestation_id",
    ];

    // return true only if all 4 values are equal
    return keysToCheck.every((key) => unitIds[key] === buildingIds[key]);
  };

  const handleAddBuilding = async (shouldShowModal) => {
    setIsSubmitting(true);
    setEachErrorBuilding("known_build_num", "");
    let isValid = false;
    let url;

    const isBuildingHasDifferentSearchType = validateBuildingFilterSearchType(
      declarationRequest,
      declarationRequest?.unit?.filter_search_type_id,
    );

    if (parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3) {
      const isMatching = validateBuildingProfileMatch(
        declarationRequest?.unit?.buildingProfile,
        declarationRequest?.unit?.building?.buildingProfile,
      );

      if (!isMatching) {
        setIsDuplicateRenin(
          "لا يمكن إضافة المبنى لأنه خارج نطاق موقع المبنى الرئيسي للمنشأة",
        );
        setIsSubmitting(false);
        return;
      } else {
        setIsDuplicateRenin("");
      }

      if (
        !canAppendBuilding(
          declarationRequest?.unit?.building?.buildingProfile,
          getMatchingBuildings(declarationRequest),
        )
      ) {
        setIsDuplicateRenin("لقد تمت إضافة هذا المبنى من قبل");
        isValid = false;
        setIsSubmitting(false);
        return;
      } else {
        setIsDuplicateRenin("");
        isValid = true;
      }

      if (
        !validateRequired(
          declarationRequest?.unit?.building?.buildingProfile?.renin,
        )
      ) {
        setUnitBuildingMapError("هذا العقار غير متاح برجاء اختيار عقار آخر");
      } else {
        setUnitBuildingMapError("");
        isValid = true;
      }

      if (!validateRequired(declarationRequest?.unit?.buildingProfile?.renin)) {
        setUnitMapError("هذا العقار غير متاح برجاء اختيار عقار آخر");
      } else {
        isValid = true;
        setUnitMapError("");
      }

      if (parseInt(building?.main_building) === 1) {
        const hasProfileNumber =
          !!declarationRequest?.unit?.buildingProfile?.number;
        const hasKnownNumber = !!declarationRequest?.unit?.known_build_num;

        if (!hasProfileNumber && !hasKnownNumber) {
          setIsDuplicateRenin(
            "لا يمكن إضافة المبنى لعدم توفر رقم العقار، برجاء تصحيح البيانات و إدخال رقم العقار/المبنى المتعارف عليه في قسم بيانات الموقع",
          );
          isValid = false;
        } else {
          setIsDuplicateRenin("");
          isValid = true;
        }
      }
    } else {
      isValid = true;
    }

    setServiceFacilityFormError("");
    error_new_user?.buildings_count && setError("buildings_count", "");

    if (isAddBuildingButtonDisabled) {
      setServiceFacilityFormError(
        "يجب أن يكون عدد المباني أكبر من إجمالي المباني المُدخلة أو مساويًا لها",
      );
      setIsSubmitting(false);
      return;
    }
    const isBuildingFormValid = validateBeforeSubmitBuilding();

    if (
      parseInt(building?.main_building) !== 1 &&
      building !== null &&
      building !== undefined
    ) {
      building.manual_known_build_num =
        building?.manual_known_build_num ||
        building?.building_manual_known_build_num;
    }

    if (isBuildingFormValid && isValid) {
      if (!isBuildingHasDifferentSearchType && shouldShowModal) {
        return setShowDeleteOther(true);
      }
      building.id = building.id || Math.random();
      building.is_edit = true;
      building.buildingProfile =
        declarationRequest?.unit?.building?.buildingProfile;

      if (declarationRequest?.unit?.id) {
        url = `api/declaration-system/declarations/${id}/units/service/${declarationRequest?.unit?.id}`;
        if (building?.id < 1) {
          delete building.id;
        }

        const data = {
          buildings_count: declarationRequest?.unit?.buildings_count,
          building: {
            ...building,
            ...(parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3
              ? {
                  buildingProfile:
                    declarationRequest?.unit?.building?.buildingProfile,
                  filter_search_type: parseInt(
                    declarationRequest?.unit?.filter_search_type_id,
                  ),
                }
              : getManualCommonBuilding(
                  declarationRequest,
                  building?.main_building ||
                    getMatchingBuildings(declarationRequest)?.length === 0
                    ? 1
                    : 0,
                  building?.id,
                )),
          },
          unit: declarationRequest?.unit,
        };

        try {
          const response = await post(
            url,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            data,
          );

          setDeclarationRequest((prev) => ({
            ...prev,
            unit: {
              ...prev.unit,
              buildings: response?.data?.unit?.buildings,
            },
          }));
        } catch (error) {
          if (error.response?.data?.errors) {
            setSubmissionError(error.response?.data?.errors);
          } else {
            setBackendError(
              error.response?.data?.message ||
                error.response?.data?.data?.message ||
                "خطأ في إرسال البيانات",
            );
          }

          if (isBuildingEditMode && buildingsBeforeEdit) {
            setDeclarationRequest((prev) => ({
              ...prev,
              unit: {
                ...prev.unit,
                buildings: buildingsBeforeEdit,
              },
            }));
          }

          window.scrollTo(0, 0);
        }
      } else {
        setDeclarationRequest((prev) => {
          const existingBuildings = Array.isArray(prev?.unit?.buildings)
            ? prev.unit.buildings
            : [];

          return {
            ...prev,
            unit: {
              ...prev.unit,
              buildings: [
                ...(prev.unit?.buildings ?? []),
                {
                  ...building,
                  ...(parseInt(
                    declarationRequest?.unit?.filter_search_type_id,
                  ) !== 3
                    ? {
                        buildingProfile:
                          declarationRequest?.unit?.building?.buildingProfile,
                        filter_search_type: parseInt(
                          declarationRequest?.unit?.filter_search_type_id,
                        ),
                        main_building:
                          building?.main_building ||
                          getMatchingBuildings(declarationRequest)?.length ===
                            0 ||
                          !isBuildingHasDifferentSearchType
                            ? 1
                            : 0,
                      }
                    : getManualCommonBuilding(
                        declarationRequest,
                        building?.main_building ||
                          getMatchingBuildings(declarationRequest)?.length ===
                            0 ||
                          !isBuildingHasDifferentSearchType
                          ? 1
                          : 0,
                        building.id,
                      )),
                },
              ],
            },
          };
        });
      }

      setIsBuildingEditMode(false);
      setBuilding(null);
      setDeclarationRequest((prev) => ({
        ...prev,
        unit: {
          ...prev.unit,
          building: null,
        },
      }));
      setBuildingValidFields({ floors_count: false, building_area: false });
    }
    setIsSubmitting(false);
  };
  /* const handleCancelBuilding = () => {
    setBuilding(staticBuilding);
    setIsBuildingEditMode(false);
    setIsDuplicateRenin("");
    setEachErrorBuilding("is_map_address_matching", "");

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings: [...(prev.unit?.buildings ?? []), staticBuilding],
        building: null,
      },
    }));
    setBuilding(null);
    setBuildingValidFields({ floors_count: false, building_area: false });
  }; */
  const handleCancelBuilding = () => {
    setIsBuildingEditMode(false);
    setIsDuplicateRenin("");
    setEachErrorBuilding("is_map_address_matching", "");

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings: buildingsBeforeEdit || [], // Restore original list
        building: null,
      },
    }));

    setBuilding(null);
    setBuildingValidFields({ floors_count: false, building_area: false });
    setBuildingsBeforeEdit(null); // cleanup
  };

  /* const handleEditBuilding = (buildingToBeEdited) => {
    setIsBuildingEditMode(true);
    setStaticBuilding(buildingToBeEdited);

    setBuilding(buildingToBeEdited);
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        building: buildingToBeEdited,
      },
    }));
    deleteFromBuildings(buildingToBeEdited.id);
  }; */
  const handleEditBuilding = (buildingToBeEdited) => {
    if (parseInt(buildingToBeEdited?.main_building) !== 1) {
      buildingToBeEdited.building_manual_known_build_num =
        buildingToBeEdited?.manual_known_build_num ||
        buildingToBeEdited?.building_manual_known_build_num;
    }
    setIsBuildingEditMode(true);

    // Save the full current list before editing
    setBuildingsBeforeEdit(getMatchingBuildings(declarationRequest) || []);

    // Safe copy
    setStaticBuilding(JSON.parse(JSON.stringify(buildingToBeEdited)));

    setBuilding(buildingToBeEdited);
    setDeclarationRequest((prev) => {
      const buildings = prev.unit?.buildings ?? [];
      const nextBuildings = buildings.filter((b) => b !== buildingToBeEdited);

      return {
        ...prev,
        unit: {
          ...prev.unit,
          buildings: nextBuildings,
          building: buildingToBeEdited,
        },
      };
    });
  };

  const handleDeleteBuilding = async (id) => {
    if (id >= 1) {
      try {
        let url = `api/declaration-system/declarations/${declarationRequest?.id}/units/service/${declarationRequest?.unit?.id}/${id}`;

        await remove(url, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
      } catch (error) {
        console.error("Failed to delete", error);
      }
    }
    setShowModal(false);
    deleteFromBuildings(id);
    return true;
  };

  const openServiceFacilityModal = (unitToDelete) => {
    setserviceFacilityToDelete(unitToDelete?.id ?? null);
    setShowModal(true);
  };

  const closeServiceFacilityModal = () => {
    setShowModal(false);
    setserviceFacilityToDelete(null);
  };

  const handleConfirmDeleteServiceFacility = async () => {
    if (serviceFacilityToDelete === null) return;
    const isDeleted = await handleDeleteBuilding(serviceFacilityToDelete);

    if (isDeleted) {
      closeServiceFacilityModal();
    }
  };

  const deleteFromBuildings = (id) => {
    setDeclarationRequest((prev) => {
      const buildings = prev.unit?.buildings ?? [];
      const nextBuildings = buildings.filter((b) => b?.id !== id);

      // If nothing changed, return prev to avoid unnecessary re-renders
      if (nextBuildings.length === buildings.length) return prev;

      return {
        ...prev,
        unit: {
          ...prev.unit,
          buildings: nextBuildings,
        },
      };
    });
  };

  const attachedEssentialDocuments = [
    {
      key: "facility_ownership_deed",
      label: "مرفق سند ملكية المنشأة",
      file: declarationRequest?.unit?.facility_ownership_deed,
    },
    {
      key: "association_bylaws",
      label: "مرفق لائحة النظام الأساسي للجمعيات",
      file: declarationRequest?.unit?.association_bylaws,
    },
    {
      key: "facility_lease_contracts",
      label: "مرفق عقود الإيجار",
      file: declarationRequest?.unit?.facility_lease_contracts,
    },
    {
      key: "building_permits",
      label: "مرفق تراخيص البناء",
      file: declarationRequest?.unit?.building_permits,
    },
    {
      key: "operating_licenses",
      label: "مرفق تراخيص التشغيل",
      file: declarationRequest?.unit?.operating_licenses,
    },
  ].filter((document) => document.file !== null && document.file !== undefined);

  const handleDeleteAllManualBuildings = async () => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings: [],
        hotelUnits: [],
      },
    }));

    handleAddBuilding(false);
    setShowDeleteOther(false);
    // setBuilding((prev) => ({
    //   ...prev,
    //   main_building: 1,
    // }));
  };

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={closeServiceFacilityModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>هل أنت متأكد من حذف هذا المبني؟</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleConfirmDeleteServiceFacility}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={closeServiceFacilityModal}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showDeleteOther}
        onRequestClose={() => showDeleteOther(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>
            في حالة تأكيد إضافة المبنى الرئيسي بإستخدام وسيلة عنوان أخرى غير
            المُدخلة مسبقا سيتم حذف المباني الأخرى نظرا لتغيير طريقة ادخال عنوان
            المبنى الرئيسي للمنشأة - و يجب إعادة استكمال بيانات المبنى الرئيسي
            في قسم وصف المباني ثم إضافة المبنى لإستكمال عملية إضافة العقار
          </h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleDeleteAllManualBuildings}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => {
                setShowDeleteOther(false);
                setIsSubmitting(false);
              }}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>

      {fields.map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      {secondaryFields.map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      <div className="row">
        <div className="d-flex align-items-center mb-4">
          <h4 className={`${stylesRequestData["box-title"]} box-title mb-0`}>
            وصف المباني
          </h4>
        </div>

        {declarationRequest?.viewMode || declarationRequest?.isUnitViewMode ? (
          <></>
        ) : (
          <>
            <CommonAddressMap
              hasNoContainer={true}
              mapType={"building"}
              NoRender={false}
              unitBuildingMapError={unitBuildingMapError}
              setUnitBuildingMapError={setUnitBuildingMapError}
              isMainBuilding={parseInt(building?.main_building) === 1}
            />

            {/* <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="known_build_num"
                labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                labelText="رقم العقار/المبنى المتعارف عليه"
                inputType="text"
                maxLength={100}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="known_build_num_input"
                name="known_build_num"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.known_build_num || ""}
                allowedPattern={
                  /^(?!0)[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                }
                onChange={handleUpdateBuilding}
                pText={errorBuilding.known_build_num}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
              />
            </div> */}

            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="floors_count"
                labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                labelText="عدد الأدوار"
                placeholder="ادخل عدد الأدوار.."
                inputType="number"
                min={1}
                step={1}
                maxLength={10}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="floors_count_input"
                name="floors_count"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.floors_count || ""}
                allowedPattern={/^[1-9]\d{0,9}$/}
                onChange={handleUpdateBuilding}
                pText={errorBuilding.floors_count}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
              />
            </div>

            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="building_area"
                labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                labelText="مساحة المبنى"
                placeholder="ادخل مساحة المبنى.."
                inputType="text"
                maxLength={10}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="building_area_input"
                name="building_area"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.building_area || ""}
                allowedPattern={/^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/}
                onChange={handleUpdateBuilding}
                pText={errorBuilding.building_area}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                popover={{
                  content: "إجمالي مساحة المبنى تساوى مسطح الدور × عدد الأدوار",
                }}
              />
            </div>

            <div className="d-flex flex-lg-row flex-column gap-3 align-items-start">
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <button
                    type="button"
                    className={
                      isAddBuildingButtonDisabled || isSubmitting
                        ? stylesRequestData["btn-add-disabled"]
                        : stylesRequestData["btn-add"]
                    }
                    onClick={() => handleAddBuilding(true)}
                    id="submit_request_data"
                  >
                    {isBuildingEditMode ? "حفظ" : "إضافة مبنى"}
                  </button>

                  {!isBuildingEditMode && (
                    <div className="d-inline-flex align-items-center gap-2">
                      <InfoPopover content="لإضافة مبنى آخر برجاء زيادة عدد المباني في قسم بيانات المنشأة">
                        <img
                          src={infoIconSvg}
                          alt="info"
                          width="18"
                          height="18"
                          style={{ display: "block" }}
                        />
                      </InfoPopover>
                    </div>
                  )}
                </div>
              </div>

              {isBuildingEditMode && (
                <div>
                  <button
                    type="button"
                    className={`${stylesRequestData["btn-cancel-building"]}`}
                    onClick={handleCancelBuilding}
                  >
                    إلغاء
                  </button>
                </div>
              )}
            </div>
            <div className="w-100 mt-1 pb-3">
              {isDuplicateRenin !== "" && (
                <p className="text-danger mb-0  me-2 fw-bolder">
                  {isDuplicateRenin}
                </p>
              )}
            </div>
          </>
        )}
      </div>

      {getMatchingBuildings(declarationRequest)?.length > 0 && (
        <>
          <div
            className={`${stylesRequestData["table-responsive"]} table-responsive mb-5`}
          >
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>المحافظة</th>
                  <th>عنوان العقار</th>
                  <th>الرقم القومي العقاري للمبنى</th>
                  {/* <th>رقم العقار/المبنى المتعارف عليه</th> */}
                  <th>العنوان مطابق لعنوان العقار محل الإقرار</th>
                  <th>سبب عدم تطابق البيانات</th>
                  <th>عدد الأدوار</th>
                  <th>مساحة المبنى</th>

                  {!declarationRequest?.viewMode &&
                    !declarationRequest?.isUnitViewMode && (
                      <>
                        {" "}
                        <th> </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {getMatchingBuildings(declarationRequest)?.length > 0 ? (
                  getMatchingBuildings(declarationRequest)?.map((unit, idx) => (
                    <tr key={unit?.id ?? `unit-${idx}`}>
                      <td data-label="المحافظة">
                        {parseInt(
                          declarationRequest?.unit?.filter_search_type_id,
                        ) !== 3 ? (
                          <>
                            {unit?.buildingProfile?.address?.goveronrate ||
                              unit?.governorate_text ||
                              "—"}
                          </>
                        ) : (
                          <>
                            {getLabelById(
                              unit?.manual_governorate_id,
                              staticGovs,
                            ) || "—"}
                          </>
                        )}
                      </td>

                      <td data-label=" عنوان العقار">
                        {(unit?.mismatch_reason_id ||
                          parseInt(
                            declarationRequest?.unit?.filter_search_type_id,
                          ) === 3) && (
                          <span
                            className="mr-1"
                            style={{
                              color:
                                parseInt(unit?.mismatch_reason_id) === 1
                                  ? "green"
                                  : parseInt(unit?.mismatch_reason_id) === 2
                                    ? "blue"
                                    : parseInt(unit?.mismatch_reason_id) === 3
                                      ? "red"
                                      : "orange",
                            }}
                          >
                            *
                          </span>
                        )}
                        {buildingFullAddressDisplay(
                          unit?.buildingProfile,
                          declarationRequest?.unit?.buildings[idx],
                        )}
                      </td>
                      <td data-label="الرقم القومي العقاري للمبنى">
                        {parseInt(
                          declarationRequest?.unit?.filter_search_type_id,
                        ) === 3 && (
                          <span
                            className="mr-1"
                            style={{
                              color: "orange",
                            }}
                          >
                            *
                          </span>
                        )}
                        {parseInt(
                          declarationRequest?.unit?.filter_search_type_id,
                        ) === 3
                          ? unit?.manual_renin || "لم يتم تحديده بعد"
                          : unit?.buildingProfile?.renin || "—"}
                      </td>
                      {/* <td data-label="رقم العقار/المبنى المتعارف عليه">
                        {unit?.known_build_num || "—"}
                      </td> */}
                      <td data-label="العنوان مطابق لعنوان العقار محل الإقرار">
                        {parseInt(
                          declarationRequest?.unit?.filter_search_type_id,
                        ) !== 3
                          ? getLabelById(
                              unit?.is_map_address_matching,
                              DoYouWantExtraAttachmentsForRequestTypes,
                            ) || "—"
                          : "—"}
                      </td>
                      <td data-label="سبب عدم تطابق البيانات">
                        {parseInt(
                          declarationRequest?.unit?.filter_search_type_id,
                        ) !== 3
                          ? getLabelById(
                              unit?.mismatch_reason_id,
                              dataMismatchReasonLookup,
                            ) || "—"
                          : "—"}
                      </td>
                      <td data-label="عدد الأدوار">
                        {unit?.floors_count ?? ""}
                      </td>
                      <td data-label="مساحة المبنى">
                        {unit?.building_area ?? ""}
                      </td>

                      {/* actions */}
                      <td data-label="إجراءات">
                        <div
                          className={`d-flex ${stylesRequestData["action-buttons-small-screen"]}`}
                        >
                          <div
                            className={`${stylesRequestData["action-buttons"]}`}
                          >
                            {canEditUnit && (
                              // parseInt(unit?.main_building) !== 1 &&
                              <>
                                <button
                                  type="button"
                                  className={`${stylesRequestData["btn-edit"]}`}
                                  onClick={() => handleEditBuilding(unit)}
                                  title="تعديل الوحدة"
                                  disabled={
                                    isBuildingEditMode ||
                                    hasFilterSearchTypeMismatch(
                                      declarationRequest,
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </button>

                                {getMatchingBuildings(declarationRequest)
                                  ?.length > 1 &&
                                  parseInt(unit?.main_building) !== 1 && (
                                    <button
                                      type="button"
                                      className={`${stylesRequestData["btn-delete-icon"]}`}
                                      onClick={() =>
                                        openServiceFacilityModal(unit)
                                      }
                                      title="حذف المبني"
                                      disabled={isBuildingEditMode}
                                    >
                                      <i className="fa-solid fa-trash-can"></i>
                                    </button>
                                  )}
                              </>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    {/* Adjust colSpan to match your actual number of columns */}
                    <td colSpan={15} className="h5 text-center">
                      لا يوجد وحدات مباني
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* <div className="col-lg-4 col-sm-6">
        <InputElement
          mb4="mb-4"
          labelHtmlFor="total_building_area"
          labelClassName={` ${stylesRequestData["form-label"]} form-label`}
          labelText="إجمالي مساحة المباني"
          inputType="text"
          inputClassName={`${stylesRequestData["form-control"]} form-control`}
          inputID="total_building_area_input"
          name="total_building_area"
          value={totalBuildingsArea}
          disabled={true}
        />
      </div> */}

      {!declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode && (
        <>
          <div className="row">
            <div className="col-md-4">
              <InputElement
                fileInputRef={ownershipDeedFileInputRef}
                mb4="mb-4"
                key={`agency-${fileInputKeys.facility_ownership_deed}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="facility_ownership_deed"
                labelClassName={`${stylesRequestData["form-label"]} form-label  `}
                labelText="سند ملكية المنشأة"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="facility_ownership_deed_input"
                name="facility_ownership_deed"
                fileName={
                  declarationRequest?.unit?.facility_ownership_deed
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["facility_ownership_deed"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.facility_ownership_deed !== null
                }
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "facility_ownership_deed",
                    null,
                  );
                  if (ownershipDeedFileInputRef?.current) {
                    ownershipDeedFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                fileInputRef={articlesOfAssociationFileInputRef}
                mb4="mb-4"
                key={`agency-${fileInputKeys.association_bylaws}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="association_bylaws"
                labelClassName={` ${stylesRequestData["form-label"]} form-label  `}
                labelText="لائحة النظام الأساسي للجمعيات"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="association_bylaws"
                name="association_bylaws"
                fileName={
                  declarationRequest?.unit?.association_bylaws
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["association_bylaws"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.association_bylaws !== null
                }
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "association_bylaws",
                    null,
                  );
                  if (articlesOfAssociationFileInputRef?.current) {
                    articlesOfAssociationFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                fileInputRef={leaseContractFileInputRef}
                mb4="mb-4"
                key={`agency-${fileInputKeys.facility_lease_contracts}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="facility_lease_contracts"
                labelClassName={` ${stylesRequestData["form-label"]} form-label  `}
                labelText="صورة من عقود الإيجار"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="facility_lease_contracts"
                name="facility_lease_contracts"
                fileName={
                  declarationRequest?.unit?.facility_lease_contracts
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["facility_lease_contracts"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.facility_lease_contracts !== null
                }
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "facility_lease_contracts",
                    null,
                  );
                  if (leaseContractFileInputRef?.current) {
                    leaseContractFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                fileInputRef={constructionLicenseFileInputRef}
                mb4="mb-4"
                key={`agency-${fileInputKeys.building_permits}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="building_permits"
                labelClassName={` ${stylesRequestData["form-label"]} form-label  `}
                labelText="صورة من تراخيص البناء"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="building_permits"
                name="building_permits"
                fileName={
                  declarationRequest?.unit?.building_permits
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["building_permits"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.building_permits !== null
                }
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                deleteFunction={() => {
                  handleChangeDeclerationUnit("", "", "building_permits", null);
                  if (constructionLicenseFileInputRef?.current) {
                    constructionLicenseFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                fileInputRef={operationLicenseFileInputRef}
                mb4="mb-4"
                key={`agency-${fileInputKeys.operating_licenses}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="operating_licenses"
                labelClassName={`${stylesRequestData["form-label"]} form-label  `}
                labelText="صورة من تراخيص التشغيل"
                inputType="file"
                fileName={
                  declarationRequest?.unit?.operating_licenses
                    ?.original_file_name || "إرفاق ملف"
                }
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="operating_licenses"
                name="operating_licenses"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["operating_licenses"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.operating_licenses !== null
                }
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "operating_licenses",
                    null,
                  );
                  if (operationLicenseFileInputRef?.current) {
                    operationLicenseFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
          </div>
        </>
      )}

      {(declarationRequest?.viewMode || declarationRequest?.isUnitViewMode) &&
        attachedEssentialDocuments.length > 0 && (
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              قائمة المستندات الأساسية
            </h4>
            <div className="row">
              {attachedEssentialDocuments.map((document) => (
                <div className="col-md-4" key={document.key}>
                  <label
                    htmlFor={document.key}
                    className={`${stylesRequestData["form-label"]} form-label`}
                  >
                    {document.label}
                  </label>
                  <div className=" col-2-4 d-flex border border-2  rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3">
                    <p
                      className="mb-0 file-name fs-6"
                      title={document.file?.original_file_name}
                    >
                      {document.file?.original_file_name}
                    </p>
                    <div className="d-flex align-items-center py-2">
                      <span
                        type="button"
                        onClick={() =>
                          handlePreviewFile(document.file?.full_url)
                        }
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-slab-press fa-regular fa-eye fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                      <span
                        type="button"
                        onClick={() => DownloadFile(document.file?.full_url)}
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default ServiceFacilityForm;
